import React, { useState, useEffect } from "react";
import { Card } from "flowbite-react";
import clsx from "clsx";
import { ArrowNext, LoadingSvg } from "../../../common/icons";
// import ErrorComponent from '../../../components/UI/error';
import ErrorComponent from "../../errors/error-box";
import PwpNotification from "../../UI/pwp-notification";

import ApiService from "../../../services/api.service";

import Helper from "../../../common/helper";
import Global from "../../../common/global";
import IconNotif from "../../../assets/images/icon.png";

export default function PayWithPoints({
  languages,
  pwpUserData,
  isRenewalPage,
  member,
  isPwpPointsEnabled,
  transactionId,
  locationData,
  pMethod,
  nbPoints,
  enoughNbPoints,
  localStorageDatas,
  pmid,
  goNextStep,
}) {
  //const [availablePoints, setAvailablePoints] = useState(true); //FOR LOCAL TESTING PWP WITH POINTS
  console.log("pwpUserData", pwpUserData);

  const [availablePoints, setAvailablePoints] = useState();
  const [primaryMember, setPrimaryMember] = useState();
  const [suppLength, setSuppLength] = useState();
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");
  const [pwpErrorMessage, setPWPErrorMessage] = useState("");

  useEffect(() => {
    if (
      locationData.PaymentMethod.PayWithPoints &&
      locationData.PaymentMethod.PayWithPoints.Enabled
    ) {
      triggerPayWithPoints();
    }
  }, []);

  async function triggerPayWithPoints() {
    // setAvailablePoints(enoughNbPoints); // COMMENT OUT FOR LOCAL TESTING PWP WITH POINTS
    setAvailablePoints(enoughNbPoints);

    let primaryMember = getPrimaryOwnerMember(localStorageDatas.members);
    setPrimaryMember(primaryMember);

    let suppMembers = getSuppLength(localStorageDatas.members);
    setSuppLength(suppMembers);
  }

  function getPrimaryOwnerMember(members) {
    let member = {};

    for (let i = 0; i < members.length; i++) {
      member = members[i];
      if (member.type_of_member == "primary_owner") {
        break;
      }
    }
    return member;
  }

  function getSuppLength(members) {
    let suppLength = 0;
    for (let i = 0; i < members.length; i++) {
      let member = members[i];
      if (member.type_of_member == "supp") {
        suppLength++;
      }
    }
    return suppLength;
  }

  function getPwpBc(business_categories) {
    for (let businessCategoryId in business_categories) {
      // console.log('pwpBc', primaryMember?.selected_product[0]?.business_category_id || businessCategoryId)
      if (isPwpPointsEnabled.exists) {
        //this is the points business category
        let business_category = business_categories[businessCategoryId];
        return {
          // "business_category_id": primaryMember?.selected_product[0]?.business_category_id || businessCategoryId,
          business_category_id: isPwpPointsEnabled.points_business_category_id,
          pricelevel:
            business_categories[isPwpPointsEnabled.points_business_category_id]
              ?.price_level_text || business_category.price_level_text,
          location: business_category.location,
          department: business_category.department,
          partner_public_category_id:
            business_category.partner_public_category_id,
          class: business_category.class,
          post_pay: isPwpPointsEnabled.post_pay_override,
          sales_type_id: business_category.sales_type_id,
          digital_card: business_category.digital_card,
          public_points_table_id: isPwpPointsEnabled.public_points_table_id,
          // "post_pay_override": isPwpPointsEnabled.post_pay_override
        };
      }
    }

    return false;
  }

  function getPwpBcRenewals(business_categories) {
    let pwpParams = {
      // "business_category_id": primaryMember?.selected_product[0]?.business_category_id || business_categories.opportunities[0].business_category_id,
      business_category_id: isPwpPointsEnabled.points_business_category_id,
      pricelevel:
        business_categories[isPwpPointsEnabled.points_business_category_id]
          ?.price_level_text ||
        business_categories.opportunities[0].price_level_text,
      location: business_categories.location,
      department: business_categories.department,
      // "partner_public_category_id": business_category.partner_public_category_id,
      class: business_categories.class,
      post_pay: isPwpPointsEnabled.post_pay_override,
      // "sales_type_id": business_category.sales_type_id,
      digital_card: business_categories.opportunities[0].digital_card,
      public_points_table_id: isPwpPointsEnabled.public_points_table_id,
      // "post_pay_override": isPwpPointsEnabled.post_pay_override
    };

    if (isPwpPointsEnabled.exists) {
      //this is the points business category
      return pwpParams;
    }
    return false;
  }

  function submitPoints(e) {
    setLoading(true);
    // e.target.disabled = true;
    let payWithPointsParams = {
      ap_transaction_id: transactionId,
      pmid: pmid,
    };

    let pwpBc;

    if (isRenewalPage) {
      pwpBc = getPwpBcRenewals(localStorageDatas.business_categories);
    } else {
      pwpBc = getPwpBc(localStorageDatas.business_categories);
    }

    if (pwpBc) {
      payWithPointsParams["bc"] = pwpBc.business_category_id;
      payWithPointsParams["pricelevel"] = pwpBc.pricelevel;
      payWithPointsParams["location"] = pwpBc.location;
      payWithPointsParams["department"] = pwpBc.department;
      payWithPointsParams["partner_public_category_id"] =
        pwpBc.partner_public_category_id || "";
      payWithPointsParams["class"] = pwpBc.class;
      payWithPointsParams["post_pay"] = pwpBc.post_pay;
      payWithPointsParams["sales_type_id"] = pwpBc.sales_type_id || "";
      payWithPointsParams["digital_card"] = pwpBc.digital_card;
      payWithPointsParams["public_points_table_id"] =
        pwpBc.public_points_table_id;
      payWithPointsParams["post_pay_override"] = pwpBc.post_pay_override;
    }

    // payWithPointsParams
    setPWPErrorMessage(""); //set Error to empty again
    ApiService.payWithPointsPayment(payWithPointsParams)
      .then((response) => response.json())
      .then(
        (result) => {
          setLoading(false);
          //the return of Points API (Success or fail)
          if (result) {
            if (result.error) {
              setPWPErrorMessage(result.error);
            } else if (result.order_complete === true) {
              goNextStep(transactionId, null, "Pay with Points");
            }
          } else {
            setPWPErrorMessage(
              "There was an error occured, please try again later"
            );
          }
        },
        (error) => {
          setPWPErrorMessage(
            "There was an error occured, please try again later"
          );
          setLoading(false);
          console.error("error", error);
        }
      );
  }

  const { salutation, firstName, lastName, currentTiering } = pwpUserData;

  if (error) {
    return <div>Error: {error}</div>;
  } else if (availablePoints && suppLength == 0) {
    // } else if(suppLength == 0) { // test if pwp has no points
    return (
      <>
        <div className="holder-reward-box mt-5 mb-5">
          <div className="holder-text-logo flex">
            <div className="holder-title mb-2">
              <p className="font-montserrat font-bold">
                {languages && languages.allRewardPoints
                  ? languages.allRewardPoints
                  : "ALL Reward points"}
              </p>
            </div>
            <div className="holder-image ml-auto">
              <img src={require("../../../assets/images/all-logo.png")} />
            </div>
          </div>
          <div className={"holder-tier flex"}>
            {currentTiering && (
              <span
                className={`tier font-montserrat ${currentTiering.toLowerCase()}`}
              >
                {currentTiering}
              </span>
            )}
          </div>
          <div className="holder-cardholder">
            <span className="font-montserrat font-bold">
              {salutation} {firstName} {lastName}
            </span>
          </div>
          <div>
            <p className="pt-1 font-montserrat">
              <p className="font-montserrat font-bold">
                {languages && languages.availableRewardPoints
                  ? languages.availableRewardPoints
                  : "Reward points available"}
                :{" "}
                <span className="font-normal">
                  {" "}
                  {Number(nbPoints).toLocaleString("en-US").replace(/,/i, " ")}
                </span>{" "}
              </p>
            </p>
          </div>
        </div>
        <div className="mt-4">
          {loading ? (
            <button
              type="button"
              className="btn btn-blue inline-block btn-processing px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out"
            >
              <span>
                {" "}
                <LoadingSvg className="process" /> &nbsp;{" "}
                {languages && languages.processing
                  ? languages.processing
                  : "Processing"}{" "}
              </span>
            </button>
          ) : (
            <button
              id="submitPointsButton"
              class="btn full inline-block px-5 py-2.5 text-black font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out btn-blue"
              onClick={(event) => submitPoints(event)}
            >
              {languages && languages.validatePayment
                ? languages.validatePayment
                : "Validate Payment"}
              <ArrowNext className="icon-next" />
            </button>
          )}
          {/* <a href="#" className='btn btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out'>USE MY ALL REWARD POINTS</a> */}
        </div>

        {pwpErrorMessage ? (
          <div class="mt-5 holder-pwp-error">
            <ErrorComponent
              errorMessage={pwpErrorMessage}
              languages={languages}
            />
          </div>
        ) : (
          ""
        )}
      </>
    );
  } else if (suppLength > 0) {
    return (
      <div className="font-medium text-gray">
        {languages && languages.pwpSecondaryErrorMessage
          ? languages.pwpSecondaryErrorMessage
          : "Cannot use points with Secondary Members."}
      </div>
    );
  } else {
    return (
      <div className="holder-receipt-uneligible holder-text text-center mt-5 mb-5">
        {/* <div className='holder-title mb-2'>
              <h5 className='text-xl tracking-tight text-gray-900 dark:text-white font-montserrat font-bold'>{languages && languages.pwpNotEligibleMessage ? languages.pwpNotEligibleMessage : 'You are not eligible to use your ALL Reward points'}</h5>
          </div>
          <div>  
              <p className='pt-1 font-montserrat'>
                <span>{languages && languages.pwpYouHave ? languages.pwpYouHave : 'You have'} </span> 
                <span>{nbPoints} </span>
                <span>{languages && languages.pwpRewardPoints ? languages.pwpRewardPoints : 'You are not eligible to use your ALL Reward points'}</span>
              </p>
          </div> */}
        <PwpNotification
          firstName={firstName}
          lastName={lastName}
          message={
            languages && languages.notEnoughPointsPWP
              ? languages.notEnoughPointsPWP
              : "it seems you don’t have enough Reward point to pay your subscription. Please choose another mean of payment."
          }
        />
        <div className="mt-5 button-receipt">
          <button className="btn full btn-blue inline-block px-6 py-2.5 text-white font-montserrat font-medium leading-tight uppercase rounded shadow-md ease-in-out">
            {languages && languages.pwpEligibleButton1
              ? languages.pwpEligibleButton1
              : "VALIDATE PAYMENT"}
            <ArrowNext className="icon-next" />
          </button>
        </div>
      </div>
    );
  }
}
